'use client'

import Image from 'next/image'
import { ReactNode } from 'react'

interface InfoCardProps {
  imageSrc: string
  imageAlt: string
  title: string | ReactNode
  description: string | ReactNode
}

export default function InfoCard({
  imageSrc,
  imageAlt,
  title,
  description,
}: InfoCardProps) {
  return (
    <div className='space-y-4 rounded-2xl bg-neutral-50'>
      <Image
        src={imageSrc}
        alt={imageAlt}
        className='w-full rounded-2xl'
        width={400}
        height={300}
      />
      <div className='p-5 pb-9'>
        {typeof title === 'string' ? (
          <h3 className='mb-3 font-criteria text-lg font-medium md:text-xl'>
            {title}
          </h3>
        ) : (
          title
        )}
        <p className='text-black-70 text-base'>{description}</p>
      </div>
    </div>
  )
}
